import taskTemplateListItemUrl from './taskTemplateListItem.html';

class TaskTemplateListItemCtrl {
  constructor($state) {
    'ngInject';

    Object.assign(this, { $state });
  }

  viewTemplate() {
    this.$state.go('shiftTasks.templates.view', { templateId: this.template.id });
  }
}

export default {
  templateUrl: taskTemplateListItemUrl,
  controller: TaskTemplateListItemCtrl,
  controllerAs: 'ctrl',
  bindings: {
    template: '<',
  },
};
